import { registrarAcao } from '@/shared/utils/reportAction';

import type { CitacaoArbitralStatus } from '../types/portalArbitralTypes';

// `Record` sobre o union: status novo ou removido no contrato quebra o `tsc` até alguém decidir o
// rótulo. Com `Record<string, string>`, tipo e mapa só ficavam em sincronia na mão.
const STATUS_CASO_ROTULO: Record<CitacaoArbitralStatus, string> = {
  ENVIANDO: 'Em análise pela Arbitralis',
  PRIMEIRA_TENTATIVA: 'Sua vez de responder',
  AGUARDANDO_LEITURA: 'Sua vez de responder',
  EM_TRATATIVA: 'Em andamento',
  MANIFESTACAO_PROTOCOLADA: 'Sua resposta foi registrada',
  INTERVENCAO_HUMANA: 'Nossa equipe está cuidando do caso',
  NAO_LOCALIZADO_PORTAL: 'Em análise pela Arbitralis',
  BLOQUEADA_CONTATO: 'Em análise pela Arbitralis',
  NAO_ENVIADO: 'Em análise pela Arbitralis',
  CONCLUIDO: 'Caso encerrado',
};

// `Object.hasOwn`: um status como "constructor" não pode achar a propriedade herdada do protótipo.
const ehStatusCasoConhecido = (status: string): status is CitacaoArbitralStatus =>
  Object.hasOwn(STATUS_CASO_ROTULO, status);

export const statusCasoRotulo = (status: CitacaoArbitralStatus | string): string => {
  if (ehStatusCasoConhecido(status)) return STATUS_CASO_ROTULO[status];
  registrarAcao('portal_arbitral.status_desconhecido', { status });
  return 'Status indisponível';
};
